import { fetchProfileForRouteGuard } from '~~/layers/base/composables/fetchProfileForRouteGuard'
import { denyStaffAdminRoute } from '~~/layers/base/utils/denyStaffAdminRoute'

/**
 * Named route middleware: users with `public.profile.is_staff` **or** `is_admin` may enter.
 * Admins are treated as staff for route access.
 *
 * Anonymous sessions and accounts without either flag are redirected to `/admin/login`.
 *
 * Usage on a page:
 * `definePageMeta({ middleware: 'is-staff' })`
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const profile = await fetchProfileForRouteGuard()
    if (!profile) {
        return denyStaffAdminRoute(to, 'unauthenticated')
    }
    if (!profile.isStaff && !profile.isAdmin) {
        return denyStaffAdminRoute(to, 'forbidden')
    }
})
